export var AUTO_HIDE_DURATION = 3000;
export var RESUME_HIDE_DURATION = 3000;
//# sourceMappingURL=constants.js.map